/*
 * Prestige - colour hover cycle
 * Fades a product card through its colour-variant images while the pointer is
 * over the card, then returns to the featured image.
 */
(() => {
  if (window.__psColorHoverInit) return;
  window.__psColorHoverInit = true;

  const INTERVAL = 900;

  const fileName = (url) => {
    if (!url) return '';
    try {
      return new URL(url, window.location.href).pathname.split('/').pop();
    } catch (error) {
      return url;
    }
  };

  const init = (overlay) => {
    if (overlay.dataset.psReady === '1') return;
    overlay.dataset.psReady = '1';

    const gallery = overlay.closest('.card-gallery');
    if (!gallery) return;

    const images = Array.from(overlay.querySelectorAll('.ps-color-hover__img'));
    if (images.length < 2) return;

    let timer = null;
    let step = 0;
    let sequence = images;

    const buildSequence = () => {
      const base = gallery.querySelector(
        'slideshow-slide:not([aria-hidden="true"]) img, .product-media-container img'
      );
      const baseName = base ? fileName(base.currentSrc || base.getAttribute('src')) : '';
      const filtered = images.filter(
        (image) => fileName(image.currentSrc || image.getAttribute('src')) !== baseName
      );
      return filtered.length ? filtered : images;
    };

    const show = (index) => {
      images.forEach((image) => image.classList.remove('is-visible'));
      if (index >= 0 && sequence[index]) sequence[index].classList.add('is-visible');
    };

    const start = () => {
      if (timer) return;
      sequence = buildSequence();
      step = 0;
      show(0);
      timer = window.setInterval(() => {
        step = (step + 1) % (sequence.length + 1);
        show(step === sequence.length ? -1 : step);
      }, INTERVAL);
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
      show(-1);
    };

    gallery.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      start();
    });
    gallery.addEventListener('pointerleave', stop);
    gallery.addEventListener('focusin', start);
    gallery.addEventListener('focusout', stop);
  };

  const scan = (root) => {
    const scope = root || document;
    if (typeof scope.querySelectorAll !== 'function') return;
    scope.querySelectorAll('.ps-color-hover').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  new MutationObserver((records) => {
    for (const record of records) {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
